// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__VwF0Y","buttons":"Footer_buttons__1N72U"};